export const amountRegex = /^([0-9])*([,.][0-9]{1,2})?$/

export const validateAmount = (value: string): boolean =>
  value.trim().length === 0 || !amountRegex.test(value)

export const transformAmount = (value: string): number =>
  parseFloat(value.replace(',', '.'))

export const formatAmountForInput = (amount: number | string | null | undefined): string => {
  if (amount == null || amount === "") return ""
  return Number(amount).toFixed(2).replace(".", ",")
}
